import { CHARGEBACK_STATUS_ENUM } from '@/enums/chargeback.enum'
import DateManager from '@/utils/date-manager.utils'

const UNKNOWN_STATUS_LABEL = 'Status desconhecido'

class ChargebackManager {
  constructor (data) {
    this.data = data
  }

  static filterAdapter (filterValue) {
    const { page, limit, status, fieldToSort, transactionId } = filterValue

    return {
      transactionId,
      page,
      sort: fieldToSort, // field name
      limit,
      status
    }
  }

  static chargebackStatusBadge (code) {
    const map = {
      [CHARGEBACK_STATUS_ENUM.WAITING_MERCHANT_EVIDENCES.code]: 'warning',
      [CHARGEBACK_STATUS_ENUM.MERCHANT_EVIDENCE_UNDER_REVIEW.code]: 'info',
      [CHARGEBACK_STATUS_ENUM.WAITING_ACQUIRER_SECOND_PRESENTMENT_PROCESSING
        .code]: 'positive',
      [CHARGEBACK_STATUS_ENUM.WON.code]: 'positive',
      [CHARGEBACK_STATUS_ENUM.LOST.code]: 'negative',
      [CHARGEBACK_STATUS_ENUM.REVERSED.code]: 'positive'
    }
    return map[code] ?? 'negative'
  }

  static chargebackStatusLabel (code) {
    const status = Object.values(CHARGEBACK_STATUS_ENUM).find(
      item => item.code === code
    )

    return status?.label ?? UNKNOWN_STATUS_LABEL
  }

  static isValidStatusToSubmitDocumentation (code) {
    return code === CHARGEBACK_STATUS_ENUM.WAITING_MERCHANT_EVIDENCES.code
  }

  static prepareFilesToValidate (files) {
    return files.map(file => ({
      filename: file.name,
      file_extension: file.type,
      file_size: file.size
    }))
  }

  static getFilesWithErrors (files, errors) {
    const processedFiles = files.map(file => {
      const error = errors.find(err => err.filename === file.name)
      return {
        name: file.name,
        error:
          !error.is_valid && !!error.validation_error.length
            ? error.validation_error[0]
            : null
      }
    })
    return processedFiles
  }

  static getChargebackExpirationDaysRemaining (createdAt) {
    const EXPIRATION_DAYS = 10
    const [dd, mm, yyyy] = createdAt.split('/')

    const chargebackDate = new Date(yyyy, mm, dd)
    const chargebackExpirationDate = new Date()
    chargebackExpirationDate.setDate(chargebackDate.getDate() + EXPIRATION_DAYS)

    return DateManager.diffInDate(new Date(), chargebackExpirationDate)
  }
}

export default ChargebackManager
